import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: '首页',
    component: HomeView
  },
  {
    path: '/myqr',
    name: '我的二维码',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/myqr.vue')
  },
  {
    path: '/cardform',
    name: '卡券表单',
    component: () => import('../views/cardform.vue')
  },
  {
    path: '/cardlist',
    name: '卡券列表',
    component: () => import('../views/cardlist.vue'),
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/cardinfo',
    name: '卡券内容',
    component: () => import('../views/cardinfo.vue')
  },
  {
    path: '/carduselist',
    name: '卡券领取记录',
    component: () => import('../views/carduselist.vue')
  },
  {
    path: '/cardview',
    name: '预览卡券',
    component: () => import('../views/cardview.vue')
  },
  {
    path: '/packageview',
    name: '卡包预览',
    component: () => import('../views/packageview.vue')
  },
  {
    path: '/packageedit',
    name: '卡包修改',
    component: () => import('../views/packageedit.vue')
  },
  {
    path: '/members',
    name: '用户',
    component: () => import('../views/members.vue'),
    meta:{
      keepAlive:true
    }
  },{
    path: '/employee',
    name: '店员',
    component: () => import('../views/employee.vue')
  },{
    path: '/mycardlist',
    name: '我的卡券',
    component: () => import('../views/mycardlist.vue'),
    meta:{
      keepAlive:true
    }
  },


  {
    path: '/mycardinfo',
    name: '我的卡券详情',
    component: () => import('../views/mycardinfo.vue')
  },
  {
    path: '/card',
    name: '优惠券',
    component: () => import('../views/card.vue')
  },
  
  {
    path: '/warranty',
    name: '质保单',
    component: () => import('../views/warranty.vue')
  },
  {
    path: '/adviser',
    name: '专属顾问',
    component: () => import('../views/adviser.vue')
  },
  {
    path: '/userset',
    name: '个人设置',
    component: () => import('../views/userset.vue')
  },
  {
    path: '/fanshen',
    name: '返审',
    component: () => import('../views/fanshen.vue')
  },


  {
    path: '/myfave',
    name: '我的收藏',
    component: () => import('../views/myfave.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
